export default {
  // Común
  common: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    add: 'Agregar',
    search: 'Buscar',
    reset: 'Restablecer',
    export: 'Exportar',
    import: 'Importar',
    upload: 'Subir',
    download: 'Descargar',
    submit: 'Enviar',
    back: 'Atrás',
    next: 'Siguiente',
    previous: 'Anterior',
    close: 'Cerrar',
    refresh: 'Actualizar',
    loading: 'Cargando...',
    success: 'Operación exitosa',
    error: 'Operación fallida',
    warning: 'Advertencia',
    info: 'Información',
    index: 'No.',
    actions: 'Acciones',
    total: 'Total {total}',
    requestFailed: 'Solicitud fallida',
    deviceOffline: 'Dispositivo desconectado',
    loginExpired: 'Sesión expirada, inicie sesión de nuevo',
    noPermission: 'Sin permiso de acceso',
    notFound: 'Recurso no encontrado',
    serverError: 'Error interno del servidor',
    networkError: 'Error de red, intente más tarde',
    networkFailed: 'Fallo de conexión, compruebe la red',
    routeLoadFailed: 'Error al cargar la ruta',
    unknownError: 'Error desconocido'
  },
  
  // Inicio de sesión
  login: {
    title: 'MLK Water Panel de Gestión',
    username: 'Nombre de usuario',
    password: 'Contraseña',
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    loginSuccess: 'Inicio de sesión exitoso',
    loginFailed: 'Inicio de sesión fallido',
    notLoggedIn: 'No ha iniciado sesión...',
    systemTitle: 'MLK Water',
    welcomeTitle: 'Bienvenido - MLK Water Panel de Gestión',
    usernameMinLength: 'El nombre de usuario debe tener al menos 2 caracteres',
    passwordFormat: 'Formato de contraseña inválido',
    verificationCode: 'Error de código de verificación (distingue mayúsculas y minúsculas)'
  },
  
  // Página de administración
  admin: {
    title: 'MLK Water Panel de Gestión',
    dashboard: 'Panel de control',
    menu: 'Menú',
    logout: 'Cerrar sesión',
    language: 'Idioma',
    chinese: '中文',
    english: 'English',
    spanish: 'Español',
    defaultUserName: 'Administrador'
  },
  
  // Gestión de dispositivos
  device: {
    title: 'Gestión de Dispositivos',
    list: 'Lista de Dispositivos',
    add: 'Agregar Dispositivo',
    edit: 'Editar Dispositivo',
    delete: 'Eliminar Dispositivo',
    status: 'Estado del Dispositivo',
    type: 'Tipo de Dispositivo',
    online: 'En línea',
    offline: 'Desconectado',
    heartbeat: 'Datos de Latido',
    record: 'Registro de Operación',
    activate: 'Registro de Activación',
    equipmentId: 'ID de equipo',
    enterEquipmentId: 'Introduzca el ID de equipo',
    equipmentType: 'Tipo de equipo',
    iotCard: 'Tarjeta IoT',
    relatedOrg: 'Organización relacionada',
    city: 'Ciudad',
    actions: 'Acciones',
    addEquipment: 'Agregar equipo y filtro',
    exportEquipment: 'Exportar equipos',
    clearTestData: 'Limpiar datos de prueba',
    allOrganizations: 'Todas las organizaciones',
    allTypes: 'Todos los tipos',
    allStatus: 'Todos los estados',
    used: 'En uso',
    unused: 'Sin usar',
    generateDate: 'Fecha de generación',
    selectDate: 'Seleccionar fecha',
    offlineDays: 'Días desconectado',
    offlineDaysPlaceholder: 'Días',
    organization: 'Organización',
    generateTime: 'Hora de generación',
    activateTime: 'Hora de activación',
    onlineStatus: 'Estado en línea',
    filterReminder: 'Recordatorio de filtro',
    remainingWater: 'Agua restante',
    lastHeartbeat: 'Último latido',
    qrCode: 'Código QR',
    notBound: 'No vinculado',
    changeCard: 'Cambiar tarjeta IoT',
    updateStatus: 'Cambiar estado',
    updateLocation: 'Cambiar ubicación',
    updateType: 'Cambiar tipo',
    transferOrg: 'Transferir organización',
    rechargeWater: 'Recargar volumen',
    waterRecord: 'Registro de recarga',
    dialogTransferTitle: 'Transferir a otra organización',
    dialogStatusTitle: 'Cambiar estado del dispositivo',
    dialogLocationTitle: 'Cambiar ubicación de estación base',
    dialogTypeTitle: 'Cambiar tipo de dispositivo',
    dialogRechargeTitle: 'Recarga de volumen',
    equipmentNo: 'No. de equipo',
    belongingOrg: 'Organización',
    statusUsed: 'En uso',
    statusUnused: 'Sin usar',
    statusRepair: 'En reparación',
    statusRepairDone: 'Reparación completada',
    inputContent: 'Introduzca el contenido',
    deviceBase: 'Estación base',
    modifyCity: 'Modificar ciudad',
    selectProvince: 'Seleccione provincia',
    cityLabel: 'Ciudad',
    selectCity: 'Seleccione ciudad',
    countyDistrict: 'Condado/Distrito',
    selectDistrict: 'Seleccione condado/distrito',
    rechargeFlow: 'Volumen de recarga',
    inputRechargeFlow: 'Introduzca el volumen de recarga',
    rechargeFlowHint: '(Recarga por defecto: 68500L)',
    equIdRequired: 'No. de equipo requerido',
    selectOrgRequired: 'Seleccione organización',
    selectStatusRequired: 'Seleccione estado',
    selectCityRequired: 'Seleccione ciudad',
    selectTypeRequired: 'Seleccione tipo de equipo',
    inputRechargeRequired: 'Introduzca el volumen de recarga',
    cardPromptMessage: 'Introduzca el nuevo número de tarjeta IoT',
    cardPromptTitle: 'Escribir número de tarjeta IoT',
    inputCardPlaceholder: 'Introduzca el número de tarjeta IoT',
    writeCardSuccess: 'Escritura correcta',
    rechargeSuccess: 'Recarga correcta'
  },

  // Registro de cambio de filtros (换芯记录)
  filterRecord: {
    title: 'Consulta de registro de cambio de filtros',
    equipmentId: 'No. de equipo',
    enterEquipmentId: 'Introduzca el no. de equipo',
    equipmentIdRequired: 'El no. de equipo es obligatorio',
    equipmentType: 'Tipo de equipo',
    allTypes: 'Todos los tipos',
    filterType: 'Tipo de filtro',
    changeTime: 'Fecha de cambio',
    changeReason: 'Motivo del cambio',
    changePerson: 'Persona que cambió',
    remark: 'Observaciones',
    homeFilter: 'Filtro doméstico',
    sharedFilter: 'Filtro compartido',
    unknown: 'Desconocido',
    filterId: 'ID de filtro',
    filterNumber: 'No. de filtro',
    number: 'º',
    filter: 'Filtro'
  },

  versionLibrary: {
    fileNameEmpty: 'El nombre del archivo no puede estar vacío',
    uploadDataError: 'Subida correcta pero el servidor devolvió datos anómalos',
    versionRequired: 'El número de versión no puede estar vacío',
    selectTypeFirst: 'Seleccione primero el tipo de equipo',
    uploadFileFirst: 'Suba primero el archivo',
    unknown: 'Error desconocido'
  },
  
  // Gestión de organizaciones
  org: {
    title: 'Gestión de Organizaciones',
    list: 'Lista de Organizaciones',
    add: 'Agregar Organización',
    edit: 'Editar Organización',
    delete: 'Eliminar Organización',
    name: 'Nombre de la Organización',
    code: 'Código de la Organización',
    type: 'Tipo de Organización'
  },
  
  // Gestión de tarjetas de agua
  card: {
    title: 'Gestión de Tarjetas de Agua',
    list: 'Lista de Tarjetas de Agua',
    add: 'Agregar Tarjeta de Agua',
    bind: 'Vincular Tarjeta de Agua',
    unbind: 'Desvincular Tarjeta de Agua',
    import: 'Importar Tarjeta de Agua',
    export: 'Exportar Tarjeta de Agua',
    serialNo: 'Número de Serie',
    cardNo: 'Número de Tarjeta',
    status: 'Estado'
  },
  
  // Configuración del sistema
  setting: {
    title: 'Configuración del Sistema',
    general: 'Configuración General',
    security: 'Configuración de Seguridad',
    notification: 'Configuración de Notificaciones'
  },
  
  // Estadísticas de datos
  stats: {
    title: 'Estadísticas de Datos',
    tds: 'Estadísticas TDS',
    volume: 'Estadísticas de Volumen',
    usage: 'Estadísticas de Uso'
  },
  
  // Pie de página
  footer: {
    copyright: '© 2023 - Tecnología Ambiental Qinghe Co., Ltd. Todos los derechos reservados',
    icp: 'Registro ICP: ',
    techSupport: '© Soporte Técnico: Guangzhou Guanjun Hydrogen Technology Co., Ltd.'
  },
  
  // Mensajes de error
  error: {
    network: 'Error de Red',
    server: 'Error del Servidor',
    permission: 'Permisos Insuficientes',
    param: 'Error de Parámetro',
    notFound: 'Datos No Encontrados',
    pageNotFound: 'Lo siento, la página que visitó no existe'
  },
  
  // Menú relacionado
  menu: {
    // Gestión de Dispositivos
    equipment: 'Biblioteca de Equipos y Filtros',
    filterRecord: 'Registro de Cambio de Filtros',
    version: 'Biblioteca de Versiones Domésticas',
    dataQuery: 'Consulta de Datos TCP',
    heartbeat: 'Datos de Latido',
    singleUse: 'Datos de Uso Único',
    bindStats: 'Estadísticas de Vinculación',
    
    // Gestión de Clientes
    customer: 'Gestión de Clientes',
    agentCheck: 'Revisión de Agentes',
    agentProfit: 'Gestión de Beneficios de Agentes',
    promotionRoute: 'Configuración de Ruta de Promoción',
    partyType: 'Gestión de Tipo de Partido',
    
    // Consulta de Datos MQTT
    mqttQuery: 'Consulta de Datos MQTT',
    statusQuery: 'Consulta de Estado',
    outputRecord: 'Consulta de Registro de Salida',
    debug: 'Página de Depuración de Dispositivos',
    waterTotal: 'Consulta de Total de Agua',
    
    // Gestión del Sistema
    adminAccount: 'Cuenta de Administrador',
    deviceType: 'Gestión de Tipo de Dispositivo',
    defaultSettings: 'Configuración Predeterminada del Sistema',
    flowConfig: 'Personalización de Flujo de Agua',
    waterConfig: 'Configuración de Temperatura y Agua',
    businessLog: 'Registro de Negocios',
    
    // Gestión de Pagos
    payment: 'Gestión de Pagos',
    order: 'Gestión de Pedidos',
    statistics: 'Estadísticas de Datos',
    waterPrice: 'Configuración de Precio del Agua',
    recharge: 'Recarga'
  }
}
